// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-row {
  text-align: center;
  padding: 45px 15px 25px;
}
ion-row .cross_img {
  height: 25px;
  width: 25px;
  position: absolute;
  top: 15px;
  right: 18px;
}
ion-row h3,
ion-row p {
  color: #313131;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
}
ion-row h3 {
  font-size: 20px;
  margin-bottom: 10px;
}
ion-row p {
  font-size: 16px;
  margin-bottom: 30px;
  font-family: AppFontLight;
}
ion-row .buttons-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
ion-row .buttons-wrap ion-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48%;
}
ion-row .buttons-wrap ion-button ion-icon {
  margin-right: 10px;
}
ion-row .buttons-wrap ion-button p {
  margin: 0;
  color: white;
  font-size: 12px;
  font-family: AppFontMedium;
}
@media (min-width: 991px) {
  ion-row .buttons-wrap ion-button p {
    font-size: 14px;
  }
}
ion-row .buttons-wrap ion-button:hover {
  --background: #FC5E07 !important;
}

.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.close-icon:hover {
  background: #f2dbd9;
}`, "",{"version":3,"sources":["webpack://./src/app/components/loyalty-components/select-where-use-coupon/select-where-use-coupon.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EAaA,uBAAA;AAbJ;AAeI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAbR;AAiBI;;EAEI,cAAA;EACA,WAAA;EACC,kBAAA;EACA,yBAAA;AAfT;AAiBI;EACI,eAAA;EACA,mBAAA;AAfR;AAiBI;EACI,eAAA;EACA,mBAAA;EACA,yBAAA;AAfR;AAiBI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAfR;AAgBQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAdZ;AAgBY;EACI,kBAAA;AAdhB;AAgBY;EACI,SAAA;EACA,YAAA;EACA,eAAA;EAIA,0BAAA;AAjBhB;AC9CE;EDwDU;IAKQ,eAAA;EAXlB;AACF;AAcY;EACI,gCAAA;AAZhB;;AAiBA;EAEI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAfJ;AAgBI;EACI,WAAA;EACA,YAAA;EACA,WAAA;AAdR;AAgBI;EACI,mBAAA;AAdR","sourcesContent":["@import '../../../../theme/mixins.scss';\n\nion-row {\n    text-align: center;\n    // display: flex;\n    // align-items: center;\n    // justify-content: space-around;\n    // flex-direction: column;\n    // padding:35px 20px 35px;\n    // background: #EBDFDA !important;\n    // position: relative;\n    // border: 1px solid var(--color-black);\n    // border-top-left-radius: 26px;\n    // border-top-right-radius: 26px;\n    // border-bottom-left-radius: 0px;\n    // border-bottom-right-radius: 0px;\n    padding: 45px 15px 25px;\n\n    .cross_img {\n        height: 25px;\n        width: 25px;    \n        position: absolute;\n        top: 15px;\n        right: 18px;\n\n    }\n\n    h3,\n    p {\n        color: #313131;\n        width: 100%;\n         text-align: center;\n         text-transform: uppercase;\n    }\n    h3 {\n        font-size: 20px;\n        margin-bottom: 10px;\n    }\n    p {\n        font-size: 16px;\n        margin-bottom: 30px;\n        font-family: AppFontLight;\n    }\n    .buttons-wrap {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n        ion-button {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            width: 48%;\n\n            ion-icon {\n                margin-right: 10px;\n            }\n            p {\n                margin: 0;\n                color: white;\n                font-size: 12px;\n                @include desktop {\n                    font-size: 14px;\n                }\n                font-family: AppFontMedium;\n            }\n            &:hover {\n                --background: #FC5E07 !important;\n            }\n        }\n    }\n}\n.close-icon {\n\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    margin: 0px;\n    background: var(--color-white-accent);\n    width: 35px;\n    height: 35px;\n    padding: 0px;\n    z-index: 99;\n    ion-icon {\n        width: 100%;\n        height: 100%;\n        margin: 0px;\n    }\n    &:hover {\n        background: #f2dbd9;\n    }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
